import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { TenantService } from '../services/tenant.service';

@Injectable({
  providedIn: 'root',
})
export class TenantResolver implements Resolve<Promise<void>> {
  private tenantService = inject(TenantService);

  async resolve(): Promise<void> {
    return this.tenantService.fetchTenants();
  }
}
